import React from "react"

const MainTenderStatus = ({ tender }): JSX.Element => {
  switch (tender?.currentBiddingRoundStatus) {
    case "opened":
      return <span className="text-success ms-2">Bidding Open</span>
    case "closed":
      return <span className="text-danger ms-2">Bidding Closed</span>
    case "submitted":
      return <span className="text-info ms-2">Bid Submitted</span>
    case "awarded":
      return <span className="text-success ms-2">Bid Awarded</span>
    default:
      return null
  }
}

const TenderStatus = ({ tender }): JSX.Element => {
  const mainStatus = <MainTenderStatus tender={tender} />

  if (!mainStatus) {
    return null
  }

  if (tender?.currentBiddingRoundDeadline) {
    return (
      <span className="d-inline-flex gap-1">
        {mainStatus}
        <span>{`(Deadline: ${tender.currentBiddingRoundDeadline})`}</span>
      </span>
    )
  }

  return mainStatus
}

export default TenderStatus
